export default {
  id: 199,
  title: 'Target #199 - Antenna',
  url: 'https://cssbattle.dev/play/199',
  colors: ['#F48B26', '#FEFF58'],
  solution:
    '<p a><p b><p c><p d><style>p[c],p[d]{bottom:-70;width:230;height:190;background:#feff58;border-radius:60px;box-shadow:inset 0 0 0 20px #feff58,inset 0 0 0 50px #f48b26}body{background:#f48b26}p{position:fixed;margin:0}p[a]{top:0;left:190;width:20;height:300;background:#feff58}p[b]{top:30;left:120;width:160;height:20;background:#feff58;border-radius:1in;box-shadow:-40px 50px #feff58,40px 50px #feff58,-80px 100px #feff58,80px 100px #feff58}p[c]{left:-70}p[d]{right:-70',
}
